import PaymentsModule from './payments.module'

export default PaymentsModule
